import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=078753dd&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=ts"
export * from "./AppMain.vue?vue&type=script&lang=ts"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=078753dd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078753dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('078753dd')) {
      api.createRecord('078753dd', component.options)
    } else {
      api.reload('078753dd', component.options)
    }
    module.hot.accept("./AppMain.vue?vue&type=template&id=078753dd&scoped=true", function () {
      api.rerender('078753dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/AppMain.vue"
export default component.exports